export var LanguageGroup;
(function (LanguageGroup) {
    LanguageGroup[LanguageGroup["Latin"] = 0] = "Latin";
    LanguageGroup[LanguageGroup["Cyrillic"] = 1] = "Cyrillic";
    LanguageGroup[LanguageGroup["Other"] = 2] = "Other";
})(LanguageGroup || (LanguageGroup = {}));
export class Language {
    constructor(shortName, alphabet, group = LanguageGroup.Latin, maxLetterLength = 2) {
        this.shortName = shortName;
        this.alphabet = alphabet;
        this.group = group;
        this.maxLetterLength = maxLetterLength;
    }
    /**
     * Returns the language with shortName equal to given value
     */
    static getByShortName(shortName) {
        return this.values.find(lang => lang.shortName == shortName);
    }
    get displayName() {
        return strings.languages[this.shortName];
    }
}
Language.cyrillicLetters = new Map([
    ["a", "а"],
    ["b", "б"],
    ["v", "в"],
    ["w", "в"],
    ["g", "г"],
    ["d", "д"],
    ["e", "е"],
    ["zh", "ж"],
    ["z", "з"],
    ["j", "й"],
    ["k", "к"],
    ["l", "л"],
    ["m", "м"],
    ["n", "н"],
    ["o", "о"],
    ["p", "п"],
    ["r", "р"],
    ["s", "с"],
    ["t", "т"],
    ["u", "у"],
    ["f", "ф"],
    ["h", "х"],
    ["x", "х"],
    ["c", "ц"],
    ["ch", "ч"],
    ["sh", "ш"],
    ["ju", "ю"],
    ["yu", "ю"],
    ["ja", "я"],
    ["ya", "я"]
]);
Language.russianBelarusianLetters = new Map([
    ["jo", "ё"],
    ["yo", "ё"],
    ["je", "э"],
    ["ye", "э"],
    ["'", "ь"],
    ["y", "ы"]
]);
Language.Ru = new Language("ru", new Map([
    ["i", "и"],
    ['"', "ъ"],
    ["shh", "щ"],
    ...Language.russianBelarusianLetters,
    ...Language.cyrillicLetters
]), LanguageGroup.Cyrillic, 3);
Language.Uk = new Language("uk", new Map([
    ["g'", "ґ"],
    ["je", "є"],
    ["ye", "є"],
    ["y", "и"],
    ["i", "і"],
    ["ji", "ї"],
    ["yi", "ї"],
    ["'", "ь"],
    ['"', "'"],
    ["shh", "щ"],
    ...Language.cyrillicLetters
]), LanguageGroup.Cyrillic, 3);
Language.Be = new Language("be", new Map([
    ["i", "і"],
    ["u'", "ў"],
    ['"', "'"],
    ...Language.cyrillicLetters,
    ...Language.russianBelarusianLetters
]), LanguageGroup.Cyrillic);
Language.Bg = new Language("bg", new Map([
    ["sht", "щ"],
    ["i", "и"],
    ["y", "ь"],
    ['"', "ъ"],
    ...Language.cyrillicLetters
]), LanguageGroup.Cyrillic);
Language.De = new Language("de", new Map([
    ["ae", "ä"],
    ["oe", "ö"],
    ["ue", "ü"],
    ["ss", "ß"]
]));
Language.frenchItalianLetters = new Map([
    ["a`", "à"],
    ["e'", "é"],
    ["e`", "è"],
    ["u`", "ù"]
]);
Language.frenchPortugueseLetters = new Map([
    ["a^", "â"],
    ["e^", "ê"],
    ["o^", "ô"],
    ["c'", "ç"]
]);
Language.Fr = new Language("fr", new Map([
    ["i^", "î"],
    ["u^", "û"],
    ['i"', "ï"],
    ['u"', "ü"],
    ['y"', "ÿ"],
    ["e'", "é"],
    ["ae", "æ"],
    ["oe", "œ"],
    ...Language.frenchItalianLetters,
    ...Language.frenchPortugueseLetters
]));
Language.Ro = new Language("ro", new Map([
    ["ae", "ă"],
    ["a^", "â"],
    ["i^", "î"],
    ["sh", "ș"],
    ["ts", "ț"]
]));
Language.Mi = new Language("mi", new Map([
    ["a-", "ā"],
    ["e-", "ē"],
    ["i-", "ī"],
    ["o-", "ō"],
    ["u-", "ū"]
]));
Language.acuteVowels = new Map([
    ["a'", "á"],
    ["i'", "í"],
    ["o'", "ó"],
    ["u'", "ú"]
]);
Language.extendedAcuteVowels = new Map([
    ...Language.acuteVowels, ["e'", "é"]
]);
Language.It = new Language("it", new Map([
    ["o'", "ó"],
    ["i`", "ì"],
    ["o`", "ò"],
    ...Language.frenchItalianLetters
]));
Language.Tr = new Language("tr", new Map([
    ["ch", "ç"],
    ["q", "ğ"],
    ['o"', "ö"],
    ["sh", "ş"],
    ['u"', "ü"]
]));
Language.DaNo = new Language("da/no", new Map([
    ["ae", "æ"],
    ["o/", "ø"],
    ["a^", "å"]
]));
Language.Sv = new Language("sv", new Map([
    ["a^", "å"],
    ['a"', "ä"],
    ['o"', "ö"]
]));
Language.Fi = new Language("fi", new Map([
    ["a^", "å"],
    ['a"', "ä"],
    ['o"', "ö"]
]));
Language.Es = new Language("es", new Map([
    ...Language.extendedAcuteVowels,
    ["n~", "ñ"],
    ['u"', "ü"]
]));
Language.Pt = new Language("pt", new Map([
    ...Language.extendedAcuteVowels,
    ...Language.frenchPortugueseLetters,
    ["a`", "à"],
    ["a~", "ã"],
    ["o~", "õ"]
]));
Language.Pl = new Language("pl", new Map([
    ["a^", "ą"],
    ["c'", "ć"],
    ["e^", "ę"],
    ["l'", "ł"],
    ["n'", "ń"],
    ["o'", "ó"],
    ["s'", "ś"],
    ["z'", "ź"],
    ["z*", "ż"]
]));
Language.Cs = new Language("cs", new Map([
    ...Language.extendedAcuteVowels,
    ["t'", "ť"],
    ["y'", "ý"],
    ["c^", "č"],
    ["d'", "ď"],
    ["e^", "ě"],
    ["n^", "ň"],
    ["r^", "ř"],
    ["s^", "š"],
    ["u^", "ů"],
    ["z^", "ž"]
]));
Language.Nl = new Language("nl", new Map([
    ...Language.extendedAcuteVowels,
    ['a"', "ä"],
    ['e"', "ë"],
    ['i"', "ï"],
    ['o"', "ö"],
    ['u"', "ü"],
    ['y"', "ÿ"],
    ["y'", "ý"]
]));
Language.Hu = new Language("hu", new Map([
    ...Language.extendedAcuteVowels,
    ['o"', "ö"],
    ['u"', "ü"],
    ["o~", "ő"],
    ["u~", "ű"]
]));
Language.icelandicFaroeseLetters = new Map([
    ...Language.acuteVowels,
    ["y'", "ý"],
    ["dh", "ð"],
    ["ae", "æ"]
]);
Language.Fo = new Language("fo", new Map([
    ...Language.icelandicFaroeseLetters, ["o/", "ø"]
]));
Language.Ic = new Language("ic", new Map([
    ...Language.icelandicFaroeseLetters,
    ["e'", "é"],
    ["th", "þ"],
    ['o"', "ö"]
]));
Language.El = new Language("el", new Map([
    ["a", "α"],
    ["b", "β"],
    ["g", "γ"],
    ["d", "δ"],
    ["e", "ε"],
    ["z", "ζ"],
    ["h", "η"],
    ["q", "θ"],
    ["i", "ι"],
    ["k", "κ"],
    ["l", "λ"],
    ["m", "μ"],
    ["n", "ν"],
    ["c", "ξ"],
    ["x", "ξ"],
    ["o", "ο"],
    ["p", "π"],
    ["r", "ρ"],
    ["s", "σ"],
    ["t", "τ"],
    ["u", "υ"],
    ["f", "φ"],
    ["x", "χ"],
    ["y", "ψ"],
    ["w", "ω"],
    ["v", "ω"],
    ["'", "ʹ"]
]), LanguageGroup.Other, 1);
Language.Ka = new Language("ka", new Map([
    ["a", "ა"],
    ["b", "ბ"],
    ["g", "გ"],
    ["d", "დ"],
    ["e", "ე"],
    ["v", "ვ"],
    ["w", "ვ"],
    ["z", "ზ"],
    ["t", "თ"],
    ["i", "ი"],
    ["k'", "კ"],
    ["l", "ლ"],
    ["m", "მ"],
    ["n", "ნ"],
    ["o", "ო"],
    ["p'", "პ"],
    ["zh", "ჟ"],
    ["r", "რ"],
    ["s", "ს"],
    ["t'", "ტ"],
    ["u", "უ"],
    ["p", "ფ"],
    ["f", "ფ"],
    ["k", "ქ"],
    ["gh", "ღ"],
    ["q", "ყ"],
    ["sh", "შ"],
    ["ch", "ჩ"],
    ["ts", "ც"],
    ["dz", "ძ"],
    ["ts'", "წ"],
    ["ch'", "ჭ"],
    ["kh", "ხ"],
    ["x", "ხ"],
    ["j", "ჯ"],
    ["h", "ჰ"]
]), LanguageGroup.Other);
Language.Translit = new Language("translit", new Map(), LanguageGroup.Latin, 1);
/** Array of all possible transliteration targets */
Language.values = [
    Language.Ru, Language.Uk, Language.Be, Language.Bg, Language.De, Language.Fr, Language.Es,
    Language.Pt, Language.It, Language.Tr, Language.DaNo, Language.Sv, Language.Fi, Language.Cs, Language.Nl,
    Language.Pl, Language.Hu, Language.Ro, Language.Mi, Language.Fo, Language.Ic, Language.El, Language.Ka
];
